import React from 'react';
import './Points.css';
import { Link } from 'react-router-dom';

import Footer from '../Footer/Footer';
import Head from '../Head/Head';
const Points = () => {
    return (
        <div className='bg'>
            <Head />
            <div className="mt-5 ml-5">
                <div class="container">
                    <div id="Latest Work" class="mt-2">
                        
                        
                        <h1 style={{ color: 'cyan', fontStyle: 'italic' }} >What do you get from this <br />Session</h1>
                        <p style={{ color: 'white', fontWeight:"700" }}>  we can get idea about the points of shundarban
                            and information of that place.That means what specialities in
                            that places and what type of plants grow there much and what
                            type of animals are there.
                        </p>
                        <br />
                        <h3 className="pra text-white">
                            Sundarbans <span style={{ color: 'yellow' }} > Points</span>
                        </h3>
                        <div class="row row-cols-1 row-cols-md-3 g-4 rounded-3">
                            <div class="col mt-5">
                                <div class="card panda-card h-100 shadow">

                                    <div class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "300px" }} id="gmap_canvas" src="https://maps.google.com/maps?q=22%C2%B004'13.42%22%20%2088%C2%B041'56.29%22&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>


                                    <div class="card-body">
                                        <h5 className="pra" >Mathurakhanda</h5>
                                        <p class="card-text">
                                            <small className="pra" >22°04'13.42"  88°41'56.29"</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col mt-5">
                                <div class="card panda-card h-100 shadow">

                                    <div class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "300px" }} width="743" height="566" id="gmap_canvas" src="https://maps.google.com/maps?q=21.8161%C2%B0%20N,%2089.4616%C2%B0%20E&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>


                                    <div class="card-body">
                                        <h5 className="pra" >Hiron Point</h5>
                                        <p class="card-text">
                                            <small className="pra" >21.8161° N, 89.4616° E</small>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col mt-5">
                                <div class="card panda-card h-100 shadow">

                                    <div class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "300px" }} id="gmap_canvas" src="https://maps.google.com/maps?q=21.8468%C2%B0%20N,%2089.5404%C2%B0%20E&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>


                                    <div class="card-body">
                                        <h5 className="pra" >
                                            Boar Point</h5>
                                        <p class="card-text">
                                            <small className="pra" >21°50'48.5"N 89°32'25.4"E</small>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col mt-5">
                                <div class="card panda-card h-100 shadow">

                                    <div class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "300px" }} id="gmap_canvas" src="https://maps.google.com/maps?q=21.7728%C2%B0%20N,%2089.5592%C2%B0%20E&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>

                                    <div class="card-body">
                                        <h5 className="pra" >Dublar Chor</h5>
                                        <p class="card-text">
                                            <small className="pra" >21°46'22.1"N 89°33'33.1"E</small>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col mt-5">
                                <div class="card panda-card h-100 shadow">

                                    <div class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "300px" }} id="gmap_canvas" src="https://maps.google.com/maps?q=21.849346,89.858659&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>


                                    <div class="card-body">
                                        <h5 className="pra" >Dimer Char</h5>
                                        <p class="card-text">
                                            <small className="pra" >21°50'57.7"N 89°51'31.2"E</small>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col mt-5">
                                <div class="card panda-card h-100 shadow">

                                    <div class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "300px" }} id="gmap_canvas" src="https://maps.google.com/maps?q=21.894252%2089.628713&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>

                                    <div class="card-body">
                                        <h5 className="pra" >Tiar Chor</h5>
                                        <p class="card-text">
                                            <small className="pra" >21°53'39.3"N 89°37'43.4"E</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Footer />

                        <br />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Points;